import { Component, ViewChild, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InstagramGalleryService } from 'src/app/services/instagram-gallery.service';
import { AccountSelectorService } from 'src/app/services/account-selector.service'; import { Capacitor } from '@capacitor/core';
import { ConfirmationService } from 'primeng/api'; import { first } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs'; import { ReplaySubject } from 'rxjs'; import { tap } from 'rxjs/operators';
import { catchError, map } from 'rxjs/operators'; import { TiktokGalleryService } from 'src/app/services/tiktok-gallery.service';
import { MessageService } from 'primeng/api'; import { GoogleGalleryService } from 'src/app/services/google-gallery.service';
@Component({
  selector: 'account-selector',
  templateUrl: './account-selector.component.html',
  styleUrls: ['./account-selector.component.scss'],
  providers: [MessageService]
})
export class AccountSelectorComponent implements OnInit {
  private readonly CACHE_KEY = 'cachedInstagramAccounts';
  private readonly CACHE_DURATION = 5 * 60 * 1000; // 5 minutos em ms
  @Input() source?: string;
  @Input() noDropdownClass = true;
  @Output() instagramAccountSelected = new EventEmitter<any>();
  @Output() accountsLoaded = new EventEmitter<any[]>();
  @Input() showLabel: boolean = true;
  facebookAccounts: any[] = [];
  instagramAccountsOptions: any[] = [];
  selectedInstagramAccountId: string | null = null;
  private _selectedAccountId: string | undefined;
  @Input() set selectedAccountId(value: string | undefined) {
    this._selectedAccountId = value;
    this.selectedInstagramAccountId = value || null;
  }
  get selectedAccountId(): string | undefined {
    return this._selectedAccountId;
  }

  constructor(
    private gallery: InstagramGalleryService,
    private accountService: AccountSelectorService,
    private tiktokService: TiktokGalleryService,
    private google: GoogleGalleryService,
    private confirmationService: ConfirmationService, private messageService: MessageService
  ) {
    console.log('[Capacitor] referenced in AccountSelectorComponent');
    }
  @Input() autoload = true;
  ngOnInit(): void {
    if (this.autoload && !this.manualLoad) {
      this.loadAccounts();
    }
  }
  displayDialogAguarde: boolean = true;

  private static _accountsCache$?: ReplaySubject<any[]>;

  @Input() feedType?: string;
  @Input() accountId?: string;

  loadAccounts(): void {
    if (this.source === 'TikTok') {
      this.loadTikTokAccounts();
      return;
    }

    // 2. YouTube
    if ((this.source || '').toLowerCase() === 'youtube' || (this.source || '').toLowerCase() === 'yt') {
      // Aqui você faz a distinção pelo tipo do feed
      if (this.feedType === 'canal' || this.feedType === 'hashtag' || this.feedType === 'playlist') {
        this.loadGoogleAccounts();
      } else if (this.feedType === 'liked' || this.feedType === 'personal_media') {
        if (this.accountId) {
          this.loadAllYoutubeChannels();
        } else {
          this.googleAccountsOptions = []; // opcional: zera para evitar confusão
          this.youtubeChannelsOptions = [];
          this.displayDialogAguarde = false;
        }
      }
      return;
    }

    if (!AccountSelectorComponent._accountsCache$) {
      AccountSelectorComponent._accountsCache$ = new ReplaySubject<any[]>(1);

      const cached = this.getCachedAccounts(); // mesmo que antes
      if (cached) {
         AccountSelectorComponent._accountsCache$.next(cached);
      } else {
        this.accountService.getInstagramAccounts()
          .pipe(catchError(() => of([])))
          .subscribe(validAccounts => {
            const contasFormatadas = this.formatAccounts(validAccounts);
            this.saveAccountsToCache(contasFormatadas); // igual antes
            AccountSelectorComponent._accountsCache$?.next(contasFormatadas);
          });
      }
    }

    this.displayDialogAguarde = true;

    AccountSelectorComponent._accountsCache$
      .pipe(first())
      .subscribe(contas => {
        this.instagramAccountsOptions = contas;
        this.displayDialogAguarde = false;
        this.accountsLoaded.emit(contas);
      });
  }
  @Input() channelId: string | null = null;
  youtubeChannelsOptions: any[] = [];
  selectedYoutubeChannelId: string | null = null;

  loadAllYoutubeChannels() {
    this.displayDialogAguarde = true;
    this.youtubeChannelsOptions = [];

    this.google.getAccounts().subscribe({
      next: (accounts) => {
        const accountRequests = accounts.map((a: any) =>
          this.google.getYoutubeChannels(a.id).pipe(
            tap((channels: any[]) => {
              // Print detalhado do primeiro canal (se existir)
              if (channels.length) {
                if (channels[0]?.snippet?.thumbnails) {
                  console.log('Thumbnails do canal:', channels[0].snippet.thumbnails);
                }
              }
            }),
            map((channels: any[]) => channels.map((c: any) => ({
              label: c.snippet?.title || c.id,
              value: c.id,
              picture: c.snippet?.thumbnails?.default?.url || 'assets/avatar-placeholder.png',
              description: c.snippet?.description || '',
              accountEmail: a.email,
              accountId: a.id
            }))),
            catchError(() => of([]))
          )
        );

        forkJoin(accountRequests).subscribe((results) => {
          this.youtubeChannelsOptions = (results as any[][]).flat();

          // Sempre adiciona a opção "Adicionar uma conta" no final
          this.youtubeChannelsOptions = this.youtubeChannelsOptions.filter(opt => opt.value !== 'add_account');
          this.youtubeChannelsOptions.push({
            id: null,
            label: 'Adicionar uma conta',
            value: 'add_account',
            picture: 'pi pi-plus'
          });

          this.displayDialogAguarde = false;
          this.selectedYoutubeChannelId = this.channelId || null;

          // if (!this.selectedYoutubeChannelId && this.youtubeChannelsOptions.length) {
          //   this.selectedYoutubeChannelId = this.youtubeChannelsOptions[0].value;
          // }
        });
      },
      error: () => {
        this.displayDialogAguarde = false;
      }
    });
  }

  get dropdownSelectedValue() {
    // YouTube (tipo liked, personal_media): usa selectedYoutubeChannelId
    if (
      (this.source || '').toLowerCase() === 'youtube' ||
      (this.source || '').toLowerCase() === 'yt'
    ) {
      if (this.feedType === 'liked' || this.feedType === 'personal_media') {
        return this.selectedYoutubeChannelId;
      }
      // canal/hashtag: usa conta google (aqui seria selectedGoogleAccountId) playlist
      if (this.feedType === 'canal' || this.feedType === 'hashtag' ||  this.feedType === 'playlist') {
        return this.selectedGoogleAccountId;
      }
    }
    // TikTok e Instagram
    return this.selectedInstagramAccountId;
  }

  set dropdownSelectedValue(value: string | null) {
    if (
      (this.source || '').toLowerCase() === 'youtube' ||
      (this.source || '').toLowerCase() === 'yt'
    ) {
      if (this.feedType === 'liked' || this.feedType === 'personal_media') {
        this.selectedYoutubeChannelId = value;
      }
      if (this.feedType === 'canal' || this.feedType === 'hashtag' || this.feedType === 'playlist') { // playlist
        this.selectedGoogleAccountId = value;
      }
    } else if ((this.source || '').toLowerCase() === 'tiktok') {
      this.selectedInstagramAccountId = value;
    } else {
      this.selectedInstagramAccountId = value;
    }
  }




  googleAccountsOptions: any[] = [];
  selectedGoogleAccountId: string | null = null;

  loadGoogleAccounts() {
    this.displayDialogAguarde = true;
    this.google.getAccounts().subscribe({
      next: (accounts) => {
        this.selectedGoogleAccountId = this.accountId || null;
        this.googleAccountsOptions = accounts.map((a: any) => ({
          label: a.name || a.username || a.email,
          value: a.id,
          picture: a.picture || 'assets/avatar-placeholder.png',
          email: a.email
        }));

        // Sempre adiciona a opção "Adicionar uma conta"
        this.googleAccountsOptions = this.googleAccountsOptions.filter(opt => opt.value !== 'add_account');
        this.googleAccountsOptions.push({
          id: null,
          label: 'Adicionar uma conta',
          value: 'add_account',
          picture: 'pi pi-plus'
        });

        this.displayDialogAguarde = false;


      },
      error: () => {
        this.displayDialogAguarde = false;
      }
    });
  }


  get dropdownOptions(): any[] {
    const source = (this.source || '').toLowerCase();
    if (source === 'youtube' || source === 'yt') {
      if (this.feedType === 'canal' || this.feedType === 'hashtag' || this.feedType === 'playlist') { // 
        return this.googleAccountsOptions;
      }
      if (this.feedType === 'liked' || this.feedType === 'personal_media') {
        return this.youtubeChannelsOptions;
      }
    }
    if (source === 'tiktok') {
      return this.instagramAccountsOptions;
    }
    // Instagram (default)
    return this.instagramAccountsOptions;
  }

  loadTikTokAccounts(): void {
    this.displayDialogAguarde = true;

    this.tiktokService.getAccounts()
      .pipe(catchError(() => of([])))
      .subscribe((accounts: any) => {
        const formatted = accounts.map((acc: any) => ({
          id: acc.id, // backend retorna o open_id do TikTok já mapeado no campo "id"
          label: acc.username,
          value: acc.id,
          picture: acc.picture,
          fbid: null // TikTok não usa
        }));

        formatted.push({
          id: null,
          label: 'Adicionar uma conta',
          value: 'add_account',
          picture: 'pi pi-plus',
          fbid: null
        });

        this.instagramAccountsOptions = formatted; // mesmo array reutilizado
        this.selectedInstagramAccountId = this.accountId || null; // pré-seleciona a conta já vinculada ao feed
        this.displayDialogAguarde = false;
      });
  }


  @Input() manualLoad = false;
  @Input() disabled = false;

  loadAccountsForFacebook(fbId: string): void {
    const cached = this.getCachedAccounts(fbId);
    const isValidCache = cached?.every(acc => acc.fbid === fbId);

    if (cached && isValidCache) {
      this.instagramAccountsOptions = [...cached];
      this.displayDialogAguarde = false;
      return;
    }

    this.displayDialogAguarde = true;

    this.gallery.listFacebookPages(10, undefined, fbId).subscribe(res => {
      const pages = res.data ?? [];

      if (pages.length === 0) {
        this.instagramAccountsOptions = [];
        this.displayDialogAguarde = false;
        return;
      }

      const calls = pages.map(page =>
        this.gallery.getInstagramAccountForPage(page.id, fbId).pipe(
          map(acc => acc ? { ...acc, page_id: page.id, pageName: page.name, fbId } : null),
          catchError(() => of(null)) // ✅ trata caso a página não tenha conta IG
        )
      );

      forkJoin(calls)
        .pipe(
          map(results => results.filter(acc => acc !== null && !!acc.id)) // ✅ só usa válidos
        )
        .subscribe(validAccounts => {
          const contasFormatadas = this.formatAccounts(validAccounts);
          this.instagramAccountsOptions = contasFormatadas;
          this.saveAccountsToCache(contasFormatadas, fbId);
          this.displayDialogAguarde = false;
        });
    });
  }



  private formatAccounts(validAccounts: any[]): any[] {
    const contasFormatadas = (validAccounts || []).map(acc => ({
      id: acc.id,
      label: acc.username ?? acc.name ?? '',
      value: acc.id,
      picture: acc.picture ?? '',
      fbid: acc.fbId,
      page_id: acc.page_id ?? null,
      pageName: acc.pageName ?? null
    }));

    contasFormatadas.push({
      id: null,
      page_id: null,
      pageName: null,
      label: 'Adicionar uma conta',
      value: 'add_account',
      picture: 'pi pi-plus',
      fbid: ''
    });

    return contasFormatadas;
  }


  @Output() accountConfirmed = new EventEmitter<{ instagramId: string, fbid: string }>();
  @Input() useAppendToBody: boolean = false;
  onSelectInstagramAccount(value: string): void {

    const src = (this.source || '').toLowerCase();

    let platformName = 'Instagram';
    let connectFn = () => this.instagramConnection();

    if (src === 'tiktok') {
      platformName = 'TikTok';
      connectFn = () => this.tiktokConnection();
    } else if (src === 'youtube' || src === 'yt') {
      platformName = 'Google';
      connectFn = () => this.googleConnection();
    }

    if (value === 'add_account') {
      this.confirmationService.confirm({
        message: `Você será redirecionado para conectar uma nova conta do ${platformName}. Deseja continuar?`,
        header: `Conectar nova conta do ${platformName}`,
        icon: 'pi pi-exclamation-triangle',
        accept: () => connectFn(),
        reject: () => { }
      });
    } else {
      // Aqui mantém igual, só cuidado com a lista de opções correta: playlist
      const lista =
        src === 'tiktok' ? this.instagramAccountsOptions
          : src === 'youtube' || src === 'yt' ? (this.feedType === 'canal' || this.feedType === 'hashtag' || this.feedType === 'playlist'
            ? this.googleAccountsOptions
            : this.youtubeChannelsOptions)
            : this.instagramAccountsOptions;

      const contaSelecionada = lista.find(acc => acc.value === value);
      const data: any = {
        instagramId: value,
        fbid: contaSelecionada?.fbid || '',
        account: contaSelecionada
      };

      // Se for YouTube canal/hashtag: o value é o id da conta Google
      if ((src === 'youtube' || src === 'yt') && (this.feedType === 'canal' || this.feedType === 'hashtag' || this.feedType === 'playlist')) {
        data.googleAccountId = value; // redundante, mas deixa explícito
      }

      // Se for YouTube liked/personal_media: o value é o id do canal, mas também precisamos do accountId
      if ((src === 'youtube' || src === 'yt') && (this.feedType === 'liked' || this.feedType === 'personal_media')) {
        data.youtubeChannelId = value;
        data.googleAccountId = contaSelecionada?.accountId; // <- pega da opção do dropdown
      }


      this.instagramAccountSelected.emit(data);

      if (this.accountConfirmed.observers.length) {
        this.accountConfirmed.emit(data);
      }
    }
  }

  private oauthChannel: BroadcastChannel | null = null;

  private startOAuthPopupListener(): void {

    if (this.oauthChannel) return;
    this.oauthChannel = new BroadcastChannel('oauth-channel');

    this.oauthChannel.onmessage = (event) => {

      switch (event.data?.type) {
        case 'instagram-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'shopify-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'tiktok-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'google-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        default:
          console.warn('⚠️ Tipo de mensagem desconhecido:', event.data?.type);
          break;
      }
    };
  }

  ngOnDestroy(): void {
    if (this.oauthChannel) {
      this.oauthChannel.close();
      this.oauthChannel = null;
    }
  }

  private storageBridge?: BroadcastChannel;

  private setupStorageBridgeForPopup(): void {
    if (this.storageBridge) return;
    this.storageBridge = new BroadcastChannel('oauth-storage');

    this.storageBridge.onmessage = (e) => {
      if (e.data?.type === 'request-storage') {
        // Envie as chaves que a popup precisa
        this.storageBridge?.postMessage({
          type: 'storage-dump',
          payload: {
            SelectedStoreId: localStorage.getItem('ss_SelectedStoreId'),
            user_id: localStorage.getItem('user_id'),
          }
        });
      }
    };
  }
  instagramConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener(); // ✅ inicia o listener

    const clientId = '4107655592889616';
    const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/instagram');
    const scopes = [
      'instagram_basic',
      'pages_show_list',
      'instagram_manage_comments',
      'pages_read_engagement',
      'pages_read_user_content',
      'business_management',
      'instagram_manage_insights',
    ].join(',');

    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));

    const oauthUrl = [
      'https://www.facebook.com/v22.0/dialog/oauth?',
      `client_id=${clientId}`,
      `&redirect_uri=${redirectUri}`,
      `&scope=${encodeURIComponent(scopes)}`,
      `&response_type=code`,
      `&state=${state}`,
    ].join('');

    window.open(oauthUrl, 'Instagram Login', 'width=600,height=700');
  }
  tiktokConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();

    const clientKey = 'sbawrbor1sxz11n05g'; // sua client_key
    const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/tiktok');
    const scopes = encodeURIComponent('user.info.basic,user.info.profile,video.list');
    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));

    const url =
      `https://www.tiktok.com/v2/auth/authorize/?client_key=${clientKey}` +
      `&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}&state=${state}`;

    window.open(url, 'TikTok Login', 'width=600,height=700,noopener,noreferrer');
  }


  googleConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();

    const clientId = '814215832533-b4qkagjc0h2voi3cf80prscqj16bfn5n.apps.googleusercontent.com';
    const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/youtube');
    const scopes = encodeURIComponent(
      'openid email profile ' +
      'https://www.googleapis.com/auth/youtube.readonly ' +
      'https://www.googleapis.com/auth/youtube.force-ssl ' +
      'https://www.googleapis.com/auth/youtube ' +
      'https://www.googleapis.com/auth/youtube.upload'
    );
    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));
    localStorage.setItem('google_oauth_state', state);

    const url =
      `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code` +
      `&scope=${scopes}` +
      `&access_type=offline` +
      `&include_granted_scopes=true` +
      `&prompt=consent` +
      `&state=${state}`;

    window.open(url, 'Google Login', 'width=600,height=700,noopener,noreferrer');
  }
  private getCachedAccounts(fbId?: string): any[] | null {
    const raw = localStorage.getItem(this.getCacheKey(fbId));
    if (!raw) return null;

    try {
      const payload = JSON.parse(raw);
      const now = Date.now();
      const fiveMinutes = 5 * 60 * 1000;
      if (now - payload.timestamp > fiveMinutes) {
        return null; // cache expirado
      }
      return payload.data;
    } catch {
      return null;
    }
  }

  private saveAccountsToCache(accounts: any[], fbId?: string): void {
    const payload = {
      timestamp: Date.now(),
      data: accounts
    };
    localStorage.setItem(this.getCacheKey(fbId), JSON.stringify(payload));
  }
  private getCacheKey(fbId?: string): string {
    return `cachedInstagramAccounts${fbId ? '_' + fbId : ''}`;
  }

  /// conexão

}

